import { render, staticRenderFns } from "./ConfirmEmail2.vue?vue&type=template&id=7c6862b0"
import script from "./ConfirmEmail2.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmail2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports